import React from 'react';
import { ImBin } from 'react-icons/im';
import './CardCheckout.scss';
import ProductImage from '../ProductImage';
import { roundNumber } from '../../helpers/functions';

type Props = {
  quality: string;
  category: string;
  imageCode: string;
  linePrice: number;
  itemPrice: number;
  length: number | null;
  width: number | null;
  quantity: number;
  color?: string;
  reference: string;
  onDelete?: () => void;
  hideAction?: boolean;
};

const CardCheckout = (props: Props) => {
  const {
    hideAction = false,
    quality,
    category,
    imageCode,
    color = '',
    // packs = null,
    linePrice,
    length = 0,
    width = 0,
    // pallets = null,
    quantity,
    itemPrice = 0,
    onDelete = () => {},
    reference = '',
  } = props;

  const renderCutsAndRolls = () => <div className="flex-row d-flex">
    <div className="checkout-item-bottom__sqm">
      <p style={{ marginBottom: 0 }}>
        <b>Width</b>
      </p>
      <p>{(width || 0)}</p>
    </div>
    <div className="checkout-item-bottom__sqm">
      <p style={{ marginBottom: 0 }}>
        <b>Length</b>
      </p>
      <p>{(length || 0)}</p>
    </div>
    <div className="checkout-item-bottom__sqm">
      <p style={{ marginBottom: 0 }}>
        <b>SQM</b>
      </p>
      <p>{(width || 0) * (length || 0)}</p>
    </div>
    <div className="checkout-item-bottom__sqm">
      <p style={{ marginBottom: 0 }}>
        <b>Price (per sqm)</b>
      </p>
      <p>£{itemPrice}</p>
    </div>
  </div>;

  const renderPacksAndPallets = () => <div className="flex-row d-flex">
    <div className="checkout-item-bottom__sqm">
      <p style={{ marginBottom: 0 }}>
        <b>Packs</b>
      </p>
      <p>{quantity}</p>
    </div>
    <div className="checkout-item-bottom__sqm">
      <p style={{ marginBottom: 0 }}>
        <b>Price (per pack)</b>
      </p>
      <p>£{itemPrice}</p>
    </div>
  </div>;


  const renderAccessories = () => <div className="flex-row d-flex">
    <div className="checkout-item-bottom__sqm">
      <p style={{ marginBottom: 0 }}>
        <b>QTY</b>
      </p>
      <p>{quantity}</p>
    </div>
    <div className="checkout-item-bottom__sqm">
      <p style={{ marginBottom: 0 }}>
        <b>Price (per unit)</b>
      </p>
      <p>£{itemPrice}</p>
    </div>
  </div>;

  const renderSwitch = () => {
    switch (category) {
      case 'ACCESSORIES':
        return renderAccessories();
      case 'LAMINATE':
      case 'LVT':
        return renderPacksAndPallets();
      default:
        return renderCutsAndRolls();
    }
  };

  return (
    <div className="checkout-item">
      <div className="checkout-item-top">
        <div className="checkout-item-top__pair">
          <div className="checkout-item-top__pair__img">
            <ProductImage imageCode={imageCode} imageAlt={imageCode} />
          </div>
          <div className="checkout-item-top__pair__desc">
            <p>
              <b>{quality} {color !== '' && `[${color}]`}</b>
            </p>
            <p>{category}</p>
          </div>
        </div>
        <div className="checkout-item-top__price">
          <p>
            {<span><b>Ref: </b>{reference || 'N/A'}</span>}
          </p>
        </div>
      </div>
      <div className="checkout-item__middle-line"></div>
      <div className="checkout-item-bottom">
        <div className="checkout-item-bottom__left">
          {renderSwitch()}
        </div>

        <div className="checkout-item-bottom__ref">
          <p>
            <b>Total:</b> £{roundNumber(linePrice)}
          </p>
        </div>
        <div className="checkout-item-top__icons">
          {!hideAction && <div onClick={onDelete} className="checkout-item-top__icons__bin">
            <ImBin style={{ fontSize: '25px', color: '#C6C6C6' }} />
          </div>}
        </div>
      </div>
    </div>
  );
};

export default CardCheckout;
